import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./hero.scss"
import {
  BackgroundKeyToColor,
  GeneralSizeKeyToPaddingNumber,
  // GeneralHeightKeyToBarHeight,
} from "../../../utils/datasources"
import Buttons from "../../internal/buttons/Buttons";
import { resolveRichText } from "../../../utils/richText"
import ModalHelper from "../../../utils/modalHelper";

const Hero = ({ blok }) => {
  const {
    hero_text,
    // header_text,
    // sub_header_text,
    background_image,
    background_color,
    padding_top,
    padding_bottom,
    cta_text,
    cta_link,
    is_modal,
    modal_id,
    cta_type,
    modal,
  } = blok

  const buttonProps = {
    text: cta_text,
    url: cta_link,
    isModal: is_modal,
    modalId: modal_id,
    cta_type: cta_type,
    component: cta_type,
    modal: modal
  }
  const backgroundColor = BackgroundKeyToColor(background_color),
    paddingTop = GeneralSizeKeyToPaddingNumber(padding_top),
    paddingBot = GeneralSizeKeyToPaddingNumber(padding_bottom)

  const heroWrapperStyles = {
    backgroundColor: backgroundColor,
    paddingTop: paddingTop,
    paddingBottom: paddingBot,
  }
  if(background_image && background_image.filename) {
    heroWrapperStyles.backgroundImage = background_image.filename
  }

  return (
    <div
      className="heroWrapper"
      style={heroWrapperStyles}
    >
      <Container className="heroContainer">
        <Row className="justify-content-center">
          <Col className="justify-content-center">
            {hero_text ? (
              <div dangerouslySetInnerHTML={resolveRichText(hero_text)}></div>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col>
            {cta_text ? (
              <>
              {modal.length ? <ModalHelper buttonProps={buttonProps} /> : <Buttons buttonProps={buttonProps} />}
              </>
              // <Buttons buttonProps={buttonProps} />
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Hero
